import {useContext} from "react";

import {AppContext} from "../app_context";

/* TODO: make more declarative, as in useModal(modal) where modal is {name, props},
    with useModal returning a channel
 */
function useModal() {
    const {modal} = useContext(AppContext);
    return modal;
}

export default useModal;
